import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../api.service';
import { Place } from '../../model/place';
import { HttpClient } from '@angular/common/http';
import WKT from 'ol/format/WKT.js';

@Component({
  selector: 'app-place-search',
  templateUrl: './place-search.component.html',
  styleUrls: ['./place-search.component.scss']
})
export class PlaceSearchComponent implements OnInit {

  @Input() onPositionSelect = (extent: number[]) => { }

  isOpen = false;

  cities = [

  ];

  selectedValue = null;

  constructor(protected apiService: ApiService, protected httpClient: HttpClient) { }

  ngOnInit() {
    this.apiService.get('places').subscribe((places: Place[]) => {
      this.cities = places.flatMap(
        (place: Place) => place.addresses.map(address => ({ geo: `${address}, ${place.name}`, name: `${address} - ${place.name}` }))
      ).sort(this.sortFunc);
    })
  }

  sortFunc(a, b) {
    const textA = a.name.toUpperCase();
    const textB = b.name.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  }

  onOpen() {
    this.isOpen = true;
  }

  onClose() {
    this.isOpen = false;
  }

  onChange() {
    if(this.selectedValue != null) {
      this.httpClient.get(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/suggest?wt=json&fl=weergavenaam,centroide_ll,geometrie_ll&q=${this.selectedValue.geo}`)
          .subscribe((result: any) => {
            const wkt = result.response.docs[0].geometrie_ll;
            const format = new WKT();
            const feature = format.readFeature(wkt, {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
            this.onPositionSelect(feature.getGeometry().getExtent())
          });
    }

    // Un-focus text box
    this.selectedValue = null;
    const tmp = document.createElement("input");
    document.body.appendChild(tmp);
    tmp.focus();
    document.body.removeChild(tmp);
  }

}
